import { z } from "zod"

export const BackofficeJobSearchResultSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    queue: z.string(),
    status: z.string(),
    timestamp: z.number(),
    finishedOn: z.number().nullable(),
    failedReason: z.string().nullable(),
    attemptsMade: z.number(),
  }),
)

export const BackofficeJobNamesResultSchema = z.array(z.string())

export const BackofficeJobRetryResultSchema = z.object({
  retried: z.number(),
})
